'use strict';

var Abreast = {
	$el: $('.abreast'),
	scene: null,

	vars: function vars() {
		this.$contents = this.$el.find('.abreast__heading, .abreast__perex, .abreast__cta');
		this.$bg = this.$el.find('.abreast__bg');
	},
	setParallaxTimeline: function setParallaxTimeline() {
		this.parallaxTimeline = new TimelineMax();

		this.parallaxTimeline.staggerFromTo(this.$contents, 1, { visibility: 'visible', opacity: 0, y: 30 }, { opacity: 1, y: 0 }, 0.2, 0.4);
	},
	initHandler: function initHandler() {
		this.vars();
		this.setParallaxTimeline();

		this.scene = new ScrollMagic.Scene({
			triggerElement: this.$el[0],
			duration: this.$el.outerHeight() / 3,
			triggerHook: 0.85
		}).setTween(this.parallaxTimeline).addTo(ScrollController.controller);
	}
};

w.autoHandle(Abreast);
;;var Modal = {
	_$currentModal: null,
	_currentName: null,
	_openClass: 'modal--open',
	_callbacks: {
		opening: [],
		opened: [],
		closing: [],
		closed: []
	},

	backdropFadeDuration: 0.5,

	initHandler: function initHandler() {
		var _this = this;

		$(document).on('click', '.modal__close, .modal', function (e) {
			//Closing modal via button or backdrop
			e.preventDefault();
			_this.close();
		}).on('click', '.modal__content', function (e) {
			//Prevent closing when clicking inside content
			e.stopImmediatePropagation();
			return false;
		}).on('click', '[data-modal]', function (e) {
			//Open modal on clicking triggers
			_this.open($(e.currentTarget).data('modal'));
			e.preventDefault();
		});
	},
	'keyboard[27]Handler': function keyboard27Handler() {
		//ESC key
		this.close();
	},
	open: function open(name) {
		var _this2 = this;

		if (this._$currentModal !== null) {
			//Modal already open or opening
			return;
		}

		var $modal = $('#modal-' + name);
		if (!$modal.length) {
			return;
		}

		this._$currentModal = $modal;
		this._currentName = name;

		this._callbacks.opening.forEach(function (cb) {
			return cb(name);
		});
		this._$currentModal.addClass(this._openClass);
		var openTl = new TimelineMax();
		openTl.fromTo(this._$currentModal, this.backdropFadeDuration, { opacity: 0 }, { opacity: 1, onComplete: function onComplete() {
				_this2._callbacks.opened.forEach(function (cb) {
					return cb(name);
				});
			} });
	},
	close: function close() {
		var _this3 = this;

		if (!this._$currentModal) {
			//No modal open or some already closing
			return;
		}

		this._callbacks.closing.forEach(function (cb) {
			return cb(_this3._currentName);
		});
		var $modal = this._$currentModal;
		var closeTl = new TimelineMax({
			onComplete: function onComplete() {
				$modal.removeClass(_this3._openClass);
				_this3._callbacks.closed.forEach(function (cb) {
					return cb(_this3._currentName);
				});
			}
		});
		closeTl.fromTo($modal, this.backdropFadeDuration, { opacity: 1 }, { opacity: 0 });
		this._$currentModal = null;
		this._currentName = null;
	},
	on: function on(event, handler) {
		if (this._callbacks[event]) {
			this._callbacks[event].push(handler);
		}
		return this;
	}
};
w.autoHandle(Modal);
;;var ModalVideoAi = {
	initHandler: function initHandler() {
		//Load video player on modal open
		var aiVideoPlayer = new Plyr('#video-ai', {
			settings: []
		});

		var hasPlayed = false;

		Modal.on('opened', function (name) {
			if (!hasPlayed && name === 'video-ai') {
				aiVideoPlayer.play();
				hasPlayed = true;
			}
		}).on('closing', function (name) {
			if (name === 'video-ai') {
				aiVideoPlayer.pause();
			}
		});
	}
};
w.autoHandle(ModalVideoAi);
;;var EventHub = {
	_callbacks: {},

	on: function on(event, handler) {
		if (!this._callbacks[event]) {
			this._callbacks[event] = [];
		}
		this._callbacks[event].push(handler);
	},
	emit: function emit(event) {
		var args = arguments;
		if (this._callbacks[event]) {
			this._callbacks[event].forEach(function (cb) {
				return cb.apply(null, args);
			});
		}
	}
};